<div [class.is-indeterminate]="isIndeterminate" [class.is-enabled]="!disabled">
  <input #control type="checkbox" (click)="onChange($event)">
  <span></span>
</div>
